import { createSelector } from "reselect";
import getDomain from "../base_getters/get_domain";

const getTrades = createSelector([
  getDomain
], (domain) => domain.trades);

export default getTrades
